import { format as dateFormat, fromUnixTime, isSameDay, parse } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

export const getDateFns = () => {
  return utcToZonedTime(new Date(), "America/Cuiaba");
};

export const parseTimestamp = (unixTimeMili) => {
  if (!unixTimeMili) return null;
  return fromUnixTime(unixTimeMili / 1000);
};

export const parseDate = (value, format = "yyyy/MM/dd") => {
  if (!value) return null;
  return parse(value, format, new Date());
};

export const formatDate = (value, format = "dd/MM/yyyy") => {
  if (!value) return null;
  return dateFormat(value, format);
};

export const formatRequestDatetime = (date) => {
  if (!date) return null;

  return date.toISOString();
};

export const formatRequestDate = (date) => {
  if (!date) return null;

  return dateFormat(date, "yyyy-MM-dd");
};

export const formatTime = (value, format = "HH:mm") => {
  if (!value) return null;
  return dateFormat(value, format);
};

export const isToday = (value) => {
  return isSameDay(value, new Date());
};
